/* ============================================================
   Anime Alley, global theme JS
   Cart drawer, AJAX add-to-cart, qty changes (Section Rendering API),
   mobile menu, predictive search, toast.
   ============================================================ */
(function () {
  'use strict';
  var theme = window.theme || {};
  var routes = theme.routes || {};

  /* ---------- helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn) { if (el) el.addEventListener(ev, fn); }

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    // Multi-currency: the shop money_format hardcodes the shop symbol, so a shopper
    // browsing in GBP saw "$57.00". When the presentment currency differs from the
    // shop currency, let Intl supply the right symbol.
    if (theme.currency && theme.shopCurrency && theme.currency !== theme.shopCurrency &&
        window.Intl && Intl.NumberFormat) {
      try {
        var loc = document.documentElement.lang || 'en';
        return new Intl.NumberFormat(loc, { style: 'currency', currency: theme.currency }).format(cents / 100);
      } catch (e) { /* fall through to the template formatter */ }
    }
    var value = '';
    var fmt = theme.moneyFormat || '${{amount}}';
    function defaultTo(v, d) { return (v == null || v === '') ? d : v; }
    function thousands(num, precision, thousandsSep, decimalSep) {
      precision = defaultTo(precision, 2);
      thousandsSep = defaultTo(thousandsSep, ',');
      decimalSep = defaultTo(decimalSep, '.');
      if (isNaN(num) || num == null) return 0;
      num = (num / 100.0).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousandsSep);
      var cents = parts[1] ? decimalSep + parts[1] : '';
      return dollars + cents;
    }
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var placeholder = match ? match[1] : 'amount';
    switch (placeholder) {
      case 'amount': value = thousands(cents, 2); break;
      case 'amount_no_decimals': value = thousands(cents, 0); break;
      case 'amount_with_comma_separator': value = thousands(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = thousands(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = thousands(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = thousands(cents, 0, ' '); break;
      default: value = thousands(cents, 2);
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }
  window.formatMoney = formatMoney;

  /* ---------- drawers ---------- */
  function openDrawer(drawer, overlay) {
    if (!drawer) return;
    drawer.classList.add('open');
    if (overlay) overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    var focusable = drawer.querySelector('button, a, input');
    if (focusable) focusable.focus();
  }
  function closeDrawer(drawer, overlay) {
    if (drawer) drawer.classList.remove('open');
    if (overlay) overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  var cartDrawer = qs('[data-cart-drawer]');
  var cartOverlay = qs('[data-cart-overlay]');
  var menuDrawer = qs('[data-menu-drawer]');
  var menuOverlay = qs('[data-menu-overlay]');
  var enableDrawer = (qs('body') && true);

  function openCart() { openDrawer(cartDrawer, cartOverlay); }
  function closeCart() { closeDrawer(cartDrawer, cartOverlay); }
  function openMenu() { openDrawer(menuDrawer, menuOverlay); }
  function closeMenu() { closeDrawer(menuDrawer, menuOverlay); }
  window.AnimeAlley = { openCart: openCart, closeCart: closeCart };

  document.addEventListener('click', function (e) {
    var cartToggle = e.target.closest('[data-cart-toggle]');
    if (cartToggle) {
      // Only hijack to drawer when drawer mode is on; otherwise let it navigate to /cart.
      if (cartDrawer && document.body.dataset.cartDrawer !== 'off') { e.preventDefault(); openCart(); }
      return;
    }
    if (e.target.closest('[data-cart-close]')) { closeCart(); }
    if (e.target.closest('[data-cart-overlay]')) { closeCart(); }
    if (e.target.closest('[data-menu-toggle]')) { e.preventDefault(); openMenu(); }
    if (e.target.closest('[data-menu-close]')) { closeMenu(); }
    if (e.target.closest('[data-menu-overlay]')) { closeMenu(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); hideSuggest(); }
  });

  /* ---------- cart counts ---------- */
  function setCartCount(count) {
    qsa('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      if (count > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden', '');
    });
    qsa('[data-cart-count-pill]').forEach(function (el) { el.textContent = count; });
  }

  /* ---------- re-render cart drawer via Section Rendering API ---------- */
  function renderCartDrawer(sectionsHtml) {
    if (!sectionsHtml) return refreshCartFromServer();
    var html = sectionsHtml['cart-drawer'];
    if (!html) return refreshCartFromServer();
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#CartDrawerContents');
    var current = qs('#CartDrawerContents');
    if (fresh && current) {
      current.replaceWith(fresh);
      setCartCount(parseInt(fresh.getAttribute('data-cart-count'), 10) || 0);
    } else {
      refreshCartFromServer();
    }
  }

  function refreshCartFromServer() {
    fetch(routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { setCartCount(cart.item_count); });
  }

  /* ---------- add to cart ---------- */
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]');
    var formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    if (btn) { btn.classList.add('cart-loading'); btn.setAttribute('aria-disabled', 'true'); }

    fetch(routes.cart_add, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) { // error (e.g. sold out)
          showFormError(form, data.description || data.message);
          return;
        }
        var title = (btn && btn.dataset.productTitle) || data.product_title || data.title;
        var img = (btn && btn.dataset.productImg) || data.image || (data.featured_image && data.featured_image.url);
        showToast(title, img);
        renderCartDrawer(data.sections);
        if (cartDrawer && document.body.dataset.cartDrawer !== 'off') openCart();
      })
      .catch(function () { showFormError(form, theme.strings && theme.strings.unavailable); })
      .finally(function () { if (btn) { btn.classList.remove('cart-loading'); btn.removeAttribute('aria-disabled'); } });
  }

  function showFormError(form, msg) {
    var box = form.querySelector('[data-form-error]');
    if (box) { box.textContent = msg || 'Something went wrong.'; box.removeAttribute('hidden'); }
    else if (msg) { alert(msg); }
  }

  document.addEventListener('submit', function (e) {
    // Only intercept cart-add forms; other forms inside <product-form> (e.g. the
    // back-in-stock customer form) must submit natively.
    var form = e.target.closest('form[data-quick-add], product-form form[action*="/cart/add"], [data-product-form]');
    if (!form) return;
    var artwork = form.querySelector('input[type="file"][data-artwork]');
    if (artwork) {
      var hasFile = artwork.files && artwork.files.length;
      // The product form is novalidate, so enforce the required artwork here.
      if (!hasFile && artwork.hasAttribute('required')) {
        e.preventDefault();
        showFormError(form, 'Please upload your artwork to continue.');
        var wrap = artwork.closest('[data-artwork-upload]');
        if (wrap) wrap.classList.add('artwork-upload--error');
        return;
      }
      // A file is attached: submit the multipart form natively so Shopify reliably
      // uploads it and attaches it to the order line item (AJAX file upload is flaky).
      if (hasFile) { form.setAttribute('enctype', 'multipart/form-data'); return; }
    }
    e.preventDefault();
    addToCart(form);
  });

  /* ---------- artwork upload (customizable products) ---------- */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('input[type="file"][data-artwork]');
    if (!input) return;
    var wrap = input.closest('[data-artwork-upload]');
    var nameEl = wrap && wrap.querySelector('[data-artwork-name]');
    var errEl = wrap && wrap.querySelector('[data-artwork-error]');
    var file = input.files && input.files[0];
    if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
    if (wrap) { wrap.classList.remove('artwork-upload--error'); wrap.classList.remove('artwork-upload--filled'); }
    if (!file) { if (nameEl) nameEl.textContent = 'No file chosen'; return; }
    if (file.size > 20 * 1024 * 1024) { // Shopify's 20 MB line-item-file limit
      input.value = '';
      if (nameEl) nameEl.textContent = 'No file chosen';
      if (errEl) { errEl.textContent = 'That file is over 20 MB. Please upload a smaller one.'; errEl.hidden = false; }
      if (wrap) wrap.classList.add('artwork-upload--error');
      return;
    }
    if (nameEl) nameEl.textContent = file.name;
    if (wrap) wrap.classList.add('artwork-upload--filled');
  });

  /* ---------- cart line qty changes ---------- */
  function changeQuantity(key, quantity) {
    if (cartDrawer) cartDrawer.classList.add('cart-loading');
    fetch(routes.cart_change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCartDrawer(cart.sections);
        // keep cart page in sync if present
        if (qs('[data-cart-page]')) window.location.reload();
      })
      .finally(function () { if (cartDrawer) cartDrawer.classList.remove('cart-loading'); });
  }

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function (e) {
      var line = e.target.closest('[data-cart-line]');
      if (!line) return;
      var key = line.getAttribute('data-key');
      var input = line.querySelector('[data-qty-input]');
      var current = parseInt(input ? input.value : '1', 10) || 1;
      if (e.target.closest('[data-qty-up]')) changeQuantity(key, current + 1);
      else if (e.target.closest('[data-qty-down]')) changeQuantity(key, Math.max(0, current - 1));
      else if (e.target.closest('[data-qty-remove]')) changeQuantity(key, 0);
    });
    cartDrawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;
      var line = input.closest('[data-cart-line]');
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 0) v = 1;
      changeQuantity(line.getAttribute('data-key'), v);
    });
  }

  /* ---------- toast ---------- */
  var toastWrap = qs('#ToastWrap');
  var toastTimer;
  function showToast(name, img) {
    if (!toastWrap) return;
    var nameEl = qs('#ToastName'); var thumb = qs('#ToastThumb');
    if (nameEl) nameEl.textContent = name || '';
    if (thumb) {
      if (img) { thumb.src = img; thumb.style.display = ''; } else { thumb.style.display = 'none'; }
    }
    toastWrap.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastWrap.classList.remove('show'); }, 2800);
  }
  on(qs('#ToastViewCart'), 'click', function () {
    toastWrap.classList.remove('show');
    if (cartDrawer && document.body.dataset.cartDrawer !== 'off') openCart();
    else window.location.href = routes.cart;
  });

  /* ---------- predictive search ---------- */
  qsa('[data-predictive-search]').forEach(function (root) {
    var input = root.querySelector('[data-predictive-input]');
    var results = root.querySelector('[data-predictive-results]');
    if (!input || !results) return;
    var timer;
    var latest = 0; // stale-response guard: only the newest request may render
    function hide() { results.setAttribute('hidden', ''); input.setAttribute('aria-expanded', 'false'); }
    window._hideSuggestFns = window._hideSuggestFns || [];
    window._hideSuggestFns.push(hide);

    function search(q) {
      var seq = ++latest;
      // Section Rendering API: the dropdown is rendered server-side in Liquid
      // (sections/predictive-search.liquid) so prices come from the first
      // IN-STOCK variant, not the cheapest one suggest.json exposes.
      var url = routes.predictive_search + '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (htmlText) {
          if (seq !== latest) return; // a newer query superseded this response
          var tmp = document.createElement('div');
          tmp.innerHTML = htmlText;
          var items = tmp.querySelector('[data-suggest-items]');
          if (!items || !items.children.length) { hide(); return; }
          var typeParam = theme.storepassSearch ? '' : '&type=product';
          results.innerHTML = items.innerHTML +
            '<a class="suggest-all" href="' + routes.search + '?q=' + encodeURIComponent(q) + typeParam + '">' +
            'See all results for &ldquo;' + escapeHtml(q) + '&rdquo;</a>';
          results.removeAttribute('hidden');
          input.setAttribute('aria-expanded', 'true');
        })
        .catch(function () { if (seq === latest) hide(); });
    }
    on(input, 'input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 1) { hide(); return; }
      timer = setTimeout(function () { search(q); }, 220);
    });
    on(input, 'focus', function () { if (input.value.trim().length >= 1 && results.children.length) results.removeAttribute('hidden'); });
    document.addEventListener('click', function (e) { if (!root.contains(e.target)) hide(); });
  });
  function hideSuggest() { (window._hideSuggestFns || []).forEach(function (fn) { fn(); }); }
  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

})();
